const is_mobile = device.mobile;
let styles = {
    container: {
        padding: '1%',
        display: 'flex',
        justifyContent: 'center',
        textAlign:'center',
        width:'auto',
        float:'center',
        flexDirection: 'column',
        marginTop:'15px',
        padding:'10px'


    },
    table: {
        backgroundColor: 'white',
        padding: '1%',
        width:'100%',
        marginLeft:'1%',
        justifyContent: 'center',
        textAlign:'center',
        alignSelf:'center',
        marginTop:'10px'
    },
    items: {
        padding: '1%',
    },
    
    item_header: {
        fontSize: '120%',
        fontWeight: 600,
        paddingLeft: '5%',
    },
    
    item_body: {
        padding: '6px ',
    },
    
    main_header: {
        padding: '1%',
        marginBottom: '3%',
        backgroundColor: '#32B6A7',
    },

    input: {
        alignSelf: 'flex-start' ,
        width: 'fit-content',
        height: 25,
      },

    court_list: {
        padding: '1%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent:'space-around',
        borderBottom: '1px solid black',
    },
    button_submit: {
        padding: '1%',
        justifyContent: 'center',
        display: 'flex',
        paddingTop: '6%',
    },
    topNav:{
        display:'grid',
        gridTemplateColumns:' 50% 50%',
        //backgroundImage:'linear-gradient(91.7deg, rgb(50, 25, 79) -4.3%, rgb(122, 101, 149) 101.8%)',
        backgroundColor:'white',
        marginBottom:'10px',
        borderRadius:'40px',
        height:'42px',
        marginTop:'1%',
        boxShadow: 'rgb(158 158 158 / 19%) 2px 3px 20px 2px',
    },
    topNavForPackages:{
        backgroundColor:'#65468a',
        color:'white',
        marginBottom:'10px',
        borderRadius:'40px',
        height:'42px',
        marginTop:'1%',
        boxShadow: 'rgb(158 158 158 / 19%) 2px 3px 20px 2px',
    },
    packageTable:{
        border:"1px solid rgb(50, 25, 79)",
    },
    packageTableRow:{
        backgroundImage:'linear-gradient(91.7deg, rgb(50, 25, 79) -4.3%, rgb(122, 101, 149) 101.8%)',
        color:'white',
    },
    pkgTabRow: {
        color:'white',
        background:'#65468a',
    },
    actionTabRow: {
        color:'white',
        background:'#65468a',
        textAlign:'center',
    },
    packageTableCom:{
        textAlign:'center',
    },
    title:{
        backgroundColor: 'rgb(101, 70, 138)',
        color: 'white',
        // borderRadius: '5px'
        position:'absolute',
        top:'0',
        left:"0"
    },
    head:{
        textAlign:'center',
        padding:'2px',
        fontWeight:'900'
    },
    closeBtn: {
        position:'absolute',
        top:'2%',
        right:'2%',
        color:'white',
        zIndex:'999',
        opacity:'1'
    },
    subBtnCon: {
        width:'100%',
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
        marginTop: is_mobile() ? '4%' : '1%'
    },
    editBtn: {
        verticalAlign:'middle',
        textAlign:'center',
    },
    addBtn: {
        display:'flex',
        justifyContent:'space-between',
        alignItems:'center',
        marginBottom:'1%',
    },
    searchContainer: {
        background: 'white',
        display: 'flex',
        alignItems: 'center',
        borderRadius: '8px',
        boxShadow:'0 2px 4px rgba(0,0,0,0.1)'
    },
    searchBar: {
        border: 'none',
        borderRight: '1px solid #d9d9d9',
        padding: '4px 8px',
        borderBottomLeftRadius: '8px',
        borderTopLeftRadius: '8px',

    },
    newPriceInput: {
        width:'100%',
        padding:'6px',
        border:'1px solid #d9d9d9',
        borderRadius:'5px'
    },
    submitPkgBtn: {
        borderRadius:'5px',
        backgroundColor:'#65468a',
        marginTop:'2%'
    },
    tableData: {
        verticalAlign:'middle',
        textAlign:'center'
    },
    discountAmt: {
        paddingLeft:'2%',
        color:'green',
        fontSize:'12px'
    },
    packAmt:{
        paddingTop:'5px',
        textAlign:'right',
        cursor:'pointer'
    },
    discountField:{
        margin: is_mobile() ? '4% 0' : '2% 0' ,
        display:'flex',
        alignItems:'center',
        flexDirection: is_mobile() ? 'column' : 'row'
    },
    gamePgm:{
        marginTop:'40px',
        marginBottom: is_mobile() ? '4%' : '2%',
        display:'flex',
        alignItems:'center',
        flexDirection: is_mobile() ? 'column' : 'row'
    },
    gameLvl: {
        marginBottom:is_mobile() ? '4%' : '2%',
        display:'flex',
        alignItems:'center',
        flexDirection:is_mobile() ? 'column' : 'row'
    },
    pkgLabel: {
        fontWeight:'bold',
        color:'#333333'
    },
    searchInfo: {
        display:'flex',
        alignItems:'center',
        gap:'3%'
    }
  }
  export default styles
  


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/editCourtPricing/style.js